var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Button as MuiButton, styled } from '@mui/material';
import React, { forwardRef } from 'react';
import Spinner from '../Spinner';
var SMuiButton = styled(MuiButton, {
    shouldForwardProp: function (prop) { return !['icon', 'danger'].includes(prop); },
    name: 'MuiButton',
    overridesResolver: function (_a) {
        var color = _a.color, variant = _a.variant, icon = _a.icon, danger = _a.danger, theme = _a.theme;
        var customOverrides = theme.components.MuiButton.customOverrides;
        return [
            icon && customOverrides.icon,
            color === 'primary' &&
                danger &&
                variant === 'contained' &&
                customOverrides.dangerPrimary,
            color === 'secondary' && danger && customOverrides.dangerSecondary,
            color === 'primary' && danger && variant === 'text' && customOverrides.dangerTertiary,
        ];
    },
})({});
var Button = forwardRef(function (_a, ref) {
    var _b = _a.color, color = _b === void 0 ? 'primary' : _b, icon = _a.icon, loading = _a.loading, danger = _a.danger, children = _a.children, props = __rest(_a, ["color", "icon", "loading", "danger", "children"]);
    var resolveLabel = function () {
        var label = children;
        if (loading && typeof loading === 'string') {
            label = loading;
        }
        return label;
    };
    var resolveColor = function () { return (color === 'tertiary' ? 'primary' : color); };
    var resolveVariant = function () { return (color === 'tertiary' ? 'text' : 'contained'); };
    var resolveSpinnerSize = function () { return (props.size === 'small' ? 12 : 16); };
    return (React.createElement(SMuiButton, __assign({ color: resolveColor(), variant: resolveVariant() }, __assign({ icon: icon, danger: danger }, props), { disabled: loading ? true : props.disabled, onClick: props.disabled || loading ? undefined : props.onClick, startIcon: (loading && React.createElement(Spinner, { color: "inherit", size: resolveSpinnerSize() })) ||
            props.startIcon, ref: ref || props.ref }), resolveLabel()));
});
// See possible solutions here:
// https://github.com/mui/material-ui/issues/15827
// It's not possible to correctly type custom Button with forwardRef.
// So we have to create a component tha is typed correctly and then use its type as typeof for our Button with forwardRef.
// ExtraProps will merge with MuiButtonProps and then we will omit color from it.
// Add ref as a prop so TS wont complain about it. But in fact it will be forwarded to MuiButton because of forwardRef.
// Second Omit is needed to register native component props (onCLick, onMouseOver, etc. )
var CorrectlyTypedButton = function (props) {
    var children = props.children, rest = __rest(props, ["children"]);
    return React.createElement(Button, __assign({}, rest), children);
};
Button.displayName = 'Button';
export default Button;
